import { Col, Grid, Menu, Row } from 'antd';
import { Link, matchRoutes, Navigate, Route, Routes, useLocation, useMatch, useNavigate, useResolvedPath } from 'react-router-dom';

import { useEffect } from 'react';
import { RouteDefinition, VerticalTabs } from '../../../shared/vertical-tabs';
import { ProfileApplyTo } from './profile-apply-to';
import { ProfileCitizenship } from './profile-citizenship';
import { ProfileContact } from './profile-contact';
import { ProfileIdentity } from './profile-identity';
import { ProfileProfession } from './profile-profession';

interface ProfileProps {}

export const Profile: React.FC<ProfileProps> = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const currentRoutePath = useResolvedPath('').pathname;
  const currentRouteMatch = useMatch(`${currentRoutePath}`);
  const screens = Grid.useBreakpoint();
  const isMobile = screens.xs;

  // Pages and their corresponding paths
  const pages = [
    {
      id: '1',
      path: 'identity',
      title: 'Identity',
      icon: undefined
    },
    {
      id: '2',
      path: 'contact',
      title: 'Contact',
      icon: undefined
    },
    {
      id: '3',
      path: 'citizenship',
      title: 'Citizenship',
      icon: undefined
    },
    {
      id: '4',
      path: 'profession',
      title: 'Profession',
      icon: undefined
    },
    {
      id: '5',
      path: 'apply-to',
      title: 'Apply To',
      icon: undefined
    }
  ];

  const routes: RouteDefinition[] = [
    { id: '1', path: 'identity/*', element: <ProfileIdentity /> },
    { id: '2', path: 'contact/*', element: <ProfileContact /> },
    { id: '3', path: 'citizenship/*', element: <ProfileCitizenship /> },
    { id: '4', path: 'profession/*', element: <ProfileProfession /> },
    { id: '5', path: 'apply-to/*', element: <ProfileApplyTo /> }
  ];

  const matchedPages = matchRoutes(
    routes.map((r) => {
      return {
        id: r.id,
        path: `${currentRoutePath}/${r.path}`
      };
    }),
    location
  );
  const matchedIds = matchedPages ? matchedPages.map((x: { route: { id: string } }) => x.route.id.toString()) : [];

  const configPageNavigationMenu = pages.map((page) => ({
    key: page.id,
    label: <Link to={page.path}>{page.title}</Link>,
    style: { width: '80%' }
  }));

  const profileNavigationMenu = pages.map((page) => ({
    key: page.id,
    label: <Link to={page.path.replace('/*', '')}>{page.title}</Link>
    // style: { width: '80%' },
  }));

  useEffect(() => {
    if (currentRouteMatch) {
      navigate(routes[0].path.replace('*', '')); // Redirect to 1st menu item
    }
  }, [currentRouteMatch, navigate]);

  return isMobile ? (
    <Col style={{ boxShadow: '-2px 0 12px rgba(0, 0, 0, 0.2)', minHeight: '100vh' }}>
      <Row>
        <Menu
          className="w-11/12"
          defaultSelectedKeys={matchedIds}
          items={profileNavigationMenu}
          mode="horizontal"
          selectedKeys={matchedIds}
          style={{ borderColor: '#3f4373' }}
        />
      </Row>
      <Row style={{ width: '100%', padding: '24px 0px 0px 24px' }}>
        <Routes>
          <Route path="/" element={<Navigate to="identity" replace />} />
          <Route path="/identity/*" element={<ProfileIdentity />} />
          <Route path="/contact/*" element={<ProfileContact />} />
          <Route path="/citizenship/*" element={<ProfileCitizenship />} />
          <Route path="/profession/*" element={<ProfileProfession />} />
          <Route path="/apply-to/*" element={<ProfileApplyTo />} />
        </Routes>
      </Row>
    </Col>
  ) : (
    <div
      style={{
        marginLeft: '33px',
        marginTop: '33px',
        minHeight: '100vh',
        minWidth: '75vw'
      }}
    >
      <VerticalTabs routes={routes} menuItems={configPageNavigationMenu} />
    </div>
  );
};
